import { AlertTriangle, ExternalLink, IdCard, ShieldCheck } from "lucide-react";

const STATUS_META = {
  not_submitted: { label: "Belum diisi", tone: "chip-tone-warn" },
  pending: { label: "Menunggu verifikasi", tone: "chip-tone-info" },
  verified: { label: "Terverifikasi", tone: "chip-tone-success" },
  needs_revision: { label: "Perlu diperbaiki", tone: "chip-tone-danger" },
};

export const PTProfileReadOnly = ({ profile, pt }) => {
  const data = profile || {};
  const status = STATUS_META[data.status] || STATUS_META.not_submitted;

  return (
    <section className="pt-card" data-testid="pt-preview-profile">
      <div className="eyebrow"><IdCard size={13} /> PROFIL PENGELOLA</div>
      <div className="pt-preview-section-head">
        <div><h2>Data Pengelola KIPK</h2><p className="muted-text">Informasi profil milik {pt.namapt}.</p></div>
        <span className={`folder-chip ${status.tone}`} data-testid="pt-preview-profile-status">{status.label}</span>
      </div>

      {data.revision_notes && (
        <div className="error-banner" data-testid="pt-preview-revision-notes">
          <AlertTriangle size={14} /> <div><strong>Catatan Admin:</strong> {data.revision_notes}</div>
        </div>
      )}
      {data.status === "not_submitted" ? (
        <div className="info-banner" data-testid="pt-preview-profile-empty">
          <ShieldCheck size={14} /> PT ini belum mengirim data pengelola.
        </div>
      ) : (
        <div className="pt-identity-grid">
          <div><span>Nama Pengelola</span><strong data-testid="pt-preview-profile-name">{data.nama_pengelola || "—"}</strong></div>
          <div><span>Jabatan</span><strong>{data.jabatan_pengelola || "—"}</strong></div>
          <div><span>Nomor WhatsApp</span><strong className="mono">{data.nomor_wa || "—"}</strong></div>
          <div><span>Alamat Email</span><strong className="mono">{data.email || "—"}</strong></div>
          <div><span>Dikirim pada</span><strong className="mono">{data.submitted_at?.slice(0, 10) || "—"}</strong></div>
          <div><span>Diverifikasi oleh</span><strong>{data.verified_by || "—"}</strong></div>
          <div className="pt-profile-link-row">
            <span>Dokumen SK Pengelola</span>
            {data.sk_link ? (
              <a href={data.sk_link} target="_blank" rel="noreferrer" className="folder-chip chip-tone-info" data-testid="pt-preview-sk-link">
                <ExternalLink size={12} /> Buka dokumen
              </a>
            ) : <strong>—</strong>}
          </div>
        </div>
      )}
    </section>
  );
};